<div
  class="tile tile-info edit-service-tile card ziro-card animate__animated animate__flipInY animate__fast"
  data-automation="edit-service-tile"
  [ngClass]="{ muted: (!isEnabled() && icon() !== ziroIcons.DUBBER_LOGO) || isDevice() }"
  [ngStyle]="{ cursor: isDevice() ? 'not-allowed' : 'pointer' }"
  (mouseenter)="isHoverTile = true"
  (mouseleave)="isHoverTile = false"
  [ngbTooltip]="getTooltip() | translate"
  #tileTooltip="ngbTooltip"
>
  <div class="tile-header">
    <span
      class="call-forwarding-button"
      data-automation="immediate-call-forwarding-icon"
      [hidden]="!isImmediateCallForwardingEnabled() || !isEnabled()"
      (mouseenter)="isHoverImmediateCallForwarding = true"
      (mouseleave)="isHoverImmediateCallForwarding = false"
      routerLink="teams-calling"
      [queryParams]="{ unansweredCallForwarding: true }"
      [ngClass]="{
        'me-1 align-middle': !isHoverTile,
        'call-forwarding-button__tile-hover-margin': isHoverTile,
      }"
      [ngbTooltip]="immediateCallForwardingTooltip() | translate"
      placement="top"
      container="body"
    >
      <i
        [ngClass]="
          isHoverImmediateCallForwarding
            ? 'fa fa-lg animate__animated animate__rubberBand animate__fast text-primary ' +
              ziroIcons.CALL_FORWARD_SMALL
            : ziroIcons.CALL_FORWARD_SMALL
        "
      ></i>
    </span>
    @if (isHoverTile) {
      <span>
        @if (isDeskPhone() && !hasMultipleDeskPhones() && isEnabled()) {
          <span
            data-automation="add-deskphone-button"
            class="add-deskphone-button me-1"
            (mouseenter)="isHoverAddDeskphone = true"
            (mouseleave)="isHoverAddDeskphone = false"
            (click)="onDeskPhoneAddClicked()"
          >
            <i
              [class]="ziroIcons.PLUS"
              [ngClass]="{
                'fa fa-lg animate__animated animate__rubberBand animate__fast text-primary': isHoverAddDeskphone,
              }"
            ></i>
          </span>
        }
        @if (isDeskPhone() && isEnabled()) {
          <span
            class="copy-deskphone-button me-1"
            (mouseenter)="isHoverCopyDeskphone = true"
            (mouseleave)="isHoverCopyDeskphone = false"
            (click)="onDeskPhoneCopyClicked()"
          >
            <i
              [ngClass]="
                isHoverCopyDeskphone
                  ? 'fa fa-lg animate__animated animate__rubberBand animate__fast text-warning ' + ziroIcons.COPY
                  : ziroIcons.COPY
              "
            ></i>
          </span>
        }
        @if (isExchangeShown() && isEnabled()) {
          <span
            class="ziro-tile-exchange me-1"
            [ngClass]="{ 'tooltip-wrapper-disabled': !isExchangeEnabled() }"
            (mouseenter)="isHoverExchange = true"
            (mouseleave)="isHoverExchange = false"
            (click)="onExchangeClicked()"
          >
            @if (!isHoverExchange || (isHoverExchange && !isExchangeEnabled())) {
              <i [ngClass]="ziroIcons.EXCHANGE_SWITCH"></i>
            }
            @if (isHoverExchange && isExchangeEnabled()) {
              <i
                class="fa fa-lg animate__animated animate__rubberBand animate__fast text-primary"
                [ngClass]="ziroIcons.EXCHANGE_SWITCH"
              ></i>
            }
          </span>
        }
        @if (isDeleteShown()) {
          <span
            [ngClass]="{ 'tooltip-wrapper-disabled': !isDeleteEnabled() }"
            class="ziro-tile-trash"
            (mouseenter)="isHoverDelete = true; tileTooltip.close()"
            (mouseleave)="isHoverDelete = false; tileTooltip.open()"
            (click)="onDeleteClicked()"
            [ngbTooltip]="deleteTooltip() | translate"
            [tooltipClass]="'tile-delete-tooltip'"
            container="body"
          >
            @if (!isHoverDelete) {
              <i [ngClass]="ziroIcons.DELETE_BIG"></i>
            }
            @if (isHoverDelete) {
              <i
                [class]="
                  ziroIcons.DELETE_SMALL + ' fa fa-lg icon-danger animate__animated animate__rubberBand animate__fast'
                "
              ></i>
            }
          </span>
        }
      </span>
    }

    @if (isDevice()) {
      <span
        style="cursor: pointer"
        [ngClass]="{
          'status-icon':
            deviceIconMarkup().includes(ziroIcons.SAVE_SUCCESS) || deviceIconMarkup().includes(ziroIcons.DISABLED),
        }"
        [ngbTooltip]="deviceToolip() | translate"
        container="body"
        [innerHtml]="deviceIconMarkup() | escapeHtml"
      ></span>
    }

    @if (isBeta()) {
      <span
        class="badge bg-warning rounded-pill align-self-center mx-1 font-size-11"
        [attr.data-automation]="'beta-tag'"
      >
        <span>
          {{ 'tkey;global.beta.text' | translate }}
        </span>
      </span>
    }

    @if (!isHoverTile && !isDeskPhone() && !isDevice() && !showWarning()) {
      <ziro-stacked-icon
        data-automation="success-icon"
        [stackedIcon]="ZiroStackedIcons[ziroIcons.SAVE_SUCCESS_CIRCLED]"
        parentClass="fa-stack status-icon"
      ></ziro-stacked-icon>
    }

    @if (showWarning()) {
      <span data-automation="warning-icon">
        <i [ngClass]="ziroIcons.WARNING_TRIANGLE" class="icon-warning cursor-default"></i>
      </span>
    }

    @if (!isHoverTile && isDeskPhone() && !isDevice()) {
      <div data-automation="phone-status-wrapper">
        @if (phoneStatus === deviceRegistrationStatus.REGISTERED) {
          <ziro-stacked-icon
            data-automation="phone-status-success-icon"
            [stackedIcon]="ZiroStackedIcons[ziroIcons.SAVE_SUCCESS_CIRCLED]"
            parentClass="fa-stack status-icon"
          ></ziro-stacked-icon>
        }
        @if (
          phoneStatusAttemptCount <= ATTEMPTS_COUNT &&
          (phoneStatus === deviceRegistrationStatus.NOT_FOUND || phoneStatus === deviceRegistrationStatus.UNREGISTERED)
        ) {
          <span data-automation="phone-status-warning-icon" class="status-icon fa-stack">
            <i [ngClass]="ziroIcons.WARNING_TRIANGLE" class="icon-warning fa-stack-2x"></i>
          </span>
        }
        @if (
          phoneStatusAttemptCount > ATTEMPTS_COUNT &&
          (phoneStatus === deviceRegistrationStatus.NOT_FOUND || phoneStatus === deviceRegistrationStatus.UNREGISTERED)
        ) {
          <span data-automation="phone-status-status-text" class="badge bg-warning badge--phone-status">
            {{ phoneStatus | phoneStatusFilter }}
          </span>
        }
      </div>
    }
  </div>

  <div
    [ngClass]="{ muted: (!isEnabled() && icon() !== ziroIcons.DUBBER_LOGO) || isDevice() }"
    (click)="onEditTileClicked()"
    class="tile-body"
  >
    <div class="tile-description">
      <div class="text-center">
        <p [ngClass]="'svg-icon-class'">
          <i [attr.data-automation]="icon()" [ngClass]="icon()" [ngStyle]="{ 'font-size': '40px' }"></i>
        </p>
        <div
          data-automation="service-tile-name"
          class="user-detail-tile-service-name"
          [ngClass]="{
            strong: !isDevice(),
          }"
        >
          {{ serviceName() | translate }}
        </div>
        <div
          data-automation="service-tile-description"
          class="user-detail-tile-description"
          [ngClass]="{
            strong: isDevice(),
          }"
        >
          {{ description() | translate }}
        </div>
        @if (isEnabled() && isHoverTile && !isDevice()) {
          <i [ngClass]="ziroIcons.EDIT" class="fa-2x text-primary"></i>
        }
      </div>
    </div>
  </div>
</div>
